module.exports = __webpack_public_path__ + "img/ae0e809.png";